var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wrap"}},[_c('div',{staticClass:"join_st",attrs:{"id":"joinPopup"}},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"inner flex-center"},[_c('div',{staticClass:"logo_box mobile"},[_c('router-link',{attrs:{"to":{ name: 'store' }}},[_c('img',{attrs:{"src":require("@/assets/images/hakji_web_logo.png"),"alt":"로고"}})])],1),_c('div',{staticClass:"box_wrap",class:{
            idlost: _vm.isIdLostPage,
            passlost: _vm.isPassLostPage,
            idfound: _vm.isIdFoundPage
          },attrs:{"data-detail":"id_search"}},[_vm._t("default")],2)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }